import { type RouteLocationRaw } from "vue-router"

export default defineNuxtPlugin(() => {
	const app = useNuxtApp()

	return {
		provide: {
			routeUrl: useRouteUrl(),
			stringUtil: useStringUtil(),
			validator: useValidator(),
			toastErrors: useToastErrors,
			backWithFallback: (to: RouteLocationRaw) => {
				if (history.state.position > 1 && history.state.back?.startsWith("/")) {
					app.$router.back()
				} else {
					app.$router.replace(to)
				}
			}
		}
	}
})
